module.exports = __webpack_public_path__ + "img/bg_figure2.a3632198.png";